export const HANDLE_LOGIN = "HANDLE_LOGIN";
export const HANDLE_LOGOUT = "HANDLE_LOGOUT";
export const HANDLE_FETCH_AMADEUS_TOKEN = "HANDLE_FETCH_AMADEUS_TOKEN";
export const FETCH_USER_PERMISSIONS = "FETCH_USER_PERMISSIONS";